import JockeyFilterComparator from './jockeyFilterComparator';
export const jockeyFilterConfig = [
    {
        label: 'name',
        stateKey: 'name',
        filterKeys: ['name'],
        hidden: true,
        comparator: JockeyFilterComparator.displayName
    },
    {
        label: 'Personality',
        stateKey: 'personality',
        filterKeys: ['personality'],
        hidden: false,
        comparator: JockeyFilterComparator.personality,
        textFilterOptions: [
            { name: 'Determined', value: 'Determined' },
            { name: 'Brave', value: 'Brave' },
            { name: 'Tempered', value: 'Tempered' },
            { name: 'Visionary', value: 'Visionary' },
            { name: 'Steadfast', value: 'Steadfast' },
            { name: 'Wise', value: 'Wise' }
        ]
    }
    //Disabling Market related content
    // {
    //     label: 'Status',
    //     stateKey: 'status',
    //     filterKeys: ['status'],
    //     hidden: false,
    //     comparator: JockeyFilterComparator.status,
    //     textFilterOptions: [
    //         { name: 'Buy now', value: 'buy_now' },
    //         { name: 'On auction', value: 'on_auction' },
    //         { name: 'Has offer', value: 'has_offer' }
    //     ]
    // }
];
